<template>
  <div>
    <div>
      <breadcrumb :breadcrumb_link="program_breadcrumb" />
    </div>
    <div class="header">
      <h1 class="overlay">PROGRAM INFORMATION</h1>
      <!--      <img src="@/assets/images/Podohotel/about_headerimage.jpg" />-->
      <div class="headerimage" />
    </div>
    <div class="container">
      <div class="row d-flex justify-content-center">
        <!--        <div>-->
        <!--          <img src="@/assets/images/pleisure/pleisure_headerimage.jpg" />-->
        <!--        </div>-->
        <div class="col-lg-12 rowSpace"></div>
        <div class="text-center col-lg-12 mainTitle">{{ $t('forest_title') }}</div>
        <div class="mainTitleLine">
          <hr />
        </div>
        <div class="col-lg-12 text-center mainIntro">{{ $t('forest_subtitle') }}</div>
        <div class="rowSpace"></div>
        <div class="col buttonArea">
          <button class="prev-button" @click="$router.go(-1)">{{ $t('prev_button') }}</button>
          <router-link
            v-show="isLang === 0"
            :to="{name: 'Realtimebooking2', params: {initProgramCode: 'P014'}}"
            class="resserve-button"
          >
            {{ $t('reserve_button') }}
          </router-link>
          <!--          <router-link to="/p/Reservpleisure/6" class="resserve-button"> 예약신청 </router-link>-->
        </div>
        <div class="rowSpace"><hr /></div>
        <GallerySlideCarousels :slides="main_slides" :slide-count="3" :thumb-slide-width="45" />
      </div>
    </div>
    <div class="container subContainer">
      <div class="row d-flex justify-content-center">
        <div class="col-lg-12 mainInfo">
          <div>{{ $t('forest_desc1') }}</div>
          <div>{{ $t('forest_desc2') }}</div>
          <div>{{ $t('forest_desc3') }}</div>
          <div>{{ $t('forest_desc4') }}</div>
          <div>{{ $t('forest_desc5') }}</div>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('forest_common_title') }}</div>
          <div class="subDatail">
            <div>{{ $t('forest_common_desc1') }}</div>
            <!--            <div>{{ $t('forest_common_desc2') }}</div>
            <div>{{ $t('forest_common_desc3') }}</div>
            <div>{{ $t('forest_common_desc4') }}</div>-->
          </div>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('forest_main_title') }}</div>
          <div class="row d-flex">
            <div v-for="(item, index) in sub_items" :key="index" class="col-lg-4 col-12 mb-4">
              <template>
                <div class="card">
                  <a :href="item.href">
                    <img class="card-img-top" :src="item.image" alt="Card image cap" style="padding: 10px"
                  /></a>
                  <div class="card-body">
                    <h5 class="card-title" style="letter-spacing: -0.02rem">{{ $t(item.title) }}</h5>
                    <p class="card-text" style="font-size: 0.8rem; word-break: keep-all; height: 5rem">
                      {{ $t(item.desc) }}
                    </p>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <!--          <div class="subDatail">-->
          <!--            <div>-->
          <!--              1. 돌오름 Up 코스 / Down 코스 : 편백나무와 삼나무 숲길, 용바위, 판상절리 계곡 등이 포함 된 트래킹 코스-->
          <!--            </div>-->
          <!--            <div>2. 프라이빗 한라산 트래킹 : 한라산의 대표적인 코스인 어리목으로 입산하여 영실코스로 하산하는 코스</div>-->
          <!--          </div>-->
          <div class="rowSpace"></div>

          <table class="web table table-bordered subTable">
            <thead>
              <tr>
                <td>{{ $t('forest_table1_tr1_td1') }}</td>
                <td>{{ $t('forest_table1_tr1_td2') }}</td>
                <td>{{ $t('forest_table1_tr1_td3') }}</td>
                <td>{{ $t('forest_table1_tr1_td4') }}</td>
                <td>{{ $t('forest_table1_tr1_td5') }}</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ $t('forest_table1_tr2_td1') }}</td>
                <td rowspan="2">{{ $t('forest_table1_tr2_td2') }}</td>
                <td>{{ $t('forest_table1_tr2_td3') }}</td>
                <td>{{ $t('forest_table1_tr2_td4') }}</td>
                <td rowspan="2">{{ $t('forest_table1_tr2_td5') }}</td>
              </tr>
              <!--              <tr>
                <td>{{ $t('forest_table1_tr3_td1') }}</td>
                <td>{{ $t('forest_table1_tr3_td2') }}</td>
                <td>{{ $t('forest_table1_tr3_td3') }}</td>
              </tr>-->
              <tr>
                <td>{{ $t('forest_table1_tr4_td1') }}</td>
                <td>{{ $t('forest_table1_tr4_td2') }}</td>
                <td>{{ $t('forest_table1_tr4_td3') }}</td>
              </tr>
            </tbody>
          </table>

          <table class="mobile table table-bordered subTable">
            <tbody>
              <tr>
                <td class="subTable2">{{ $t('forest_table1_tr1_td1') }}</td>
                <td>{{ $t('forest_table1_tr2_td1') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('forest_table1_tr1_td2') }}</td>
                <td>{{ $t('forest_table1_tr2_td2') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('forest_table1_tr1_td3') }}</td>
                <td>{{ $t('forest_table1_tr2_td3') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('forest_table1_tr1_td4') }}</td>
                <td>{{ $t('forest_table1_tr2_td4') }}</td>
              </tr>
              <tr>
                <td class="subTable3">{{ $t('forest_table1_tr1_td5') }}</td>
                <td>{{ $t('forest_table1_tr2_td5') }}</td>
              </tr>
            </tbody>
          </table>

          <!--          <table class="mobile table table-bordered subTable">
            <tbody>
              <tr>
                <td class="subTable2">{{ $t('forest_table1_tr1_td1') }}</td>
                <td>{{ $t('forest_table1_tr3_td1') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('forest_table1_tr1_td2') }}</td>
                <td>{{ $t('forest_table1_tr2_td2') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('forest_table1_tr1_td3') }}</td>
                <td>{{ $t('forest_table1_tr3_td2') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('forest_table1_tr1_td4') }}</td>
                <td>{{ $t('forest_table1_tr3_td3') }}</td>
              </tr>
              <tr>
                <td class="subTable3">{{ $t('forest_table1_tr1_td5') }}</td>
                <td>{{ $t('forest_table1_tr2_td5') }}</td>
              </tr>
            </tbody>
          </table>-->

          <table class="mobile table table-bordered subTable">
            <tbody>
              <tr>
                <td class="subTable2">{{ $t('forest_table1_tr1_td1') }}</td>
                <td>{{ $t('forest_table1_tr4_td1') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('forest_table1_tr1_td2') }}</td>
                <td>{{ $t('forest_table1_tr2_td2') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('forest_table1_tr1_td3') }}</td>
                <td>{{ $t('forest_table1_tr4_td2') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('forest_table1_tr1_td4') }}</td>
                <td>{{ $t('forest_table1_tr4_td3') }}</td>
              </tr>
              <tr>
                <td class="subTable3">{{ $t('forest_table1_tr1_td5') }}</td>
                <td>{{ $t('forest_table1_tr2_td5') }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="rowSpace"><hr /></div>
      <div class="row d-flex justify-content-center">
        <!--        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('forest_addition_title') }}</div>

          <GallerySlideCarousels :slides="addition_slides" :slide-count="3" :thumb-slide-width="50" />

          <table class="col-lg-12 table table-bordered subTable">
            <thead>
              <tr>
                <td>{{ $t('forest_table2_tr1_td1') }}</td>
                <td colspan="2">{{ $t('forest_table2_tr1_td2') }}</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ $t('forest_table2_tr2_td1') }}</td>
                <td>{{ $t('forest_table2_tr2_td2') }}</td>
                <td rowspan="4">{{ $t('forest_table2_tr2_td3') }}</td>
              </tr>
              <tr>
                <td>{{ $t('forest_table2_tr3_td1') }}</td>
                <td>{{ $t('forest_table2_tr3_td2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('forest_table2_tr4_td1') }}</td>
                <td>{{ $t('forest_table2_tr4_td2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('forest_table2_tr5_td1') }}</td>
                <td>{{ $t('forest_table2_tr5_td2') }}</td>
              </tr>
            </tbody>
          </table>
        </div>-->
        <!--        <div class="rowSpace"><hr /></div>-->
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('forest_etc_title') }}</div>
          <div class="subDetail">
            <div>{{ $t('forest_etc_desc1') }}</div>
            <div>{{ $t('forest_etc_desc2') }}</div>
            <div>{{ $t('forest_etc_desc3') }}</div>
            <div>{{ $t('forest_etc_desc4') }}</div>
            <div>{{ $t('forest_etc_desc5') }}</div>
            <!--            <div>{{ $t('forest_etc_desc6') }}</div>-->
            <div>{{ $t('forest_etc_desc7') }}</div>
          </div>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col buttonArea">
          <button class="prev-button" @click="$router.go(-1)">{{ $t('prev_button') }}</button>
          <router-link
            v-show="isLang === 0"
            :to="{name: 'Realtimebooking2', params: {initProgramCode: 'P014'}}"
            class="resserve-button"
          >
            {{ $t('reserve_button') }}
          </router-link>
          <!--          <router-link to="/p/Reservpleisure/6" class="resserve-button"> 예약신청 </router-link>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import GallerySlideCarousels from '@/components/GallerySlideCarousels';

export default {
  name: 'forestoytellingtour',
  data() {
    return {
      isLang: 0,
      program_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'PROGRAM',
        present: this.$t('breadcrumb'),
      },
      main_slides: [
        {image: require('@/assets/images/pleisure/program/forestorytellingtour_main_04.jpg')},
        {image: require('@/assets/images/pleisure/program/forestorytellingtour_main_01.jpg')},
        {image: require('@/assets/images/pleisure/program/forestorytellingtour_main_02.jpg')},
        {image: require('@/assets/images/pleisure/program/forestorytellingtour_main_03.jpg')},
        {image: require('@/assets/images/pleisure/program/forestorytellingtour_main_06.jpg')},
        {image: require('@/assets/images/pleisure/program/forestorytellingtour_main_07.jpg')},
      ],
      addition_slides: [
        {image: require('@/assets/images/pleisure/program/forestorytellingtour_option_01.jpg')},
        {image: require('@/assets/images/pleisure/program/forestorytellingtour_option_02.jpg')},
        {image: require('@/assets/images/pleisure/program/forestorytellingtour_option_03.jpg')},
      ],
      sub_items: [
        {
          title: 'forest_mainp_title1',
          desc: 'forest_mainp_desc1',
          image: require('@/assets/images/pleisure/program/forestorytellingtour_main_02.jpg'),
        },
        /*{
          title: 'forest_mainp_title2',
          desc: 'forest_mainp_desc2',
          image: require('@/assets/images/pleisure/program/forestorytellingtour_main_03.jpg'),
        },*/
        {
          title: 'forest_mainp_title3',
          desc: 'forest_mainp_desc3',
          image: require('@/assets/images/pleisure/program/forestorytellingtour_main_05.jpg'),
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }

      this.program_breadcrumb = {
        toplink: 'HOME',
        prevlink: 'PROGRAM',
        present: this.$t('breadcrumb'),
      };

      this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  components: {Breadcrumb, GallerySlideCarousels},
};
</script>

<style scoped lang="scss">
.header {
  position: relative;
  width: 100%;
  > img {
    width: 100%;
  }

  .overlay {
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}
td {
  vertical-align: middle;
}
.top {
  padding-top: 11rem;
}
.mainTitle {
  font-weight: 800;
  font-size: 2rem;
  letter-spacing: -0.1rem;
}
.mainTitleLine {
  width: 10%;
  > hr {
  }
}
.mainIntro {
}
.buttonArea {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .resserve-button {
    width: 8rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    background-color: #524a3d;
    color: #fff;
  }
  .prev-button {
    justify-content: center;
    width: 8rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    background-color: white;
    color: #000;
    border: 1px solid black;
  }
}
.subContainer {
  width: 100%;
}
.mainInfo {
  padding: 1rem;
  width: 100%;
  height: 100%;
  > div {
    line-height: 1.5rem;
    font-size: 1rem;
  }
}
.serviceArea {
  padding: 1rem;
  > span {
    font-size: 0.8rem;
  }
}
.subTitle {
  font-weight: 600;
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
}
.subDetail {
  font-size: 0.9rem;
  padding-left: 1rem;
}
.subTable {
  > thead {
    background-color: #eaeaea;

    > tr > td {
      text-align: center;
      font-weight: 600;
    }
  }
  > tbody {
    > tr > td {
      text-align: center;
      font-size: 0.9rem;
      word-break: keep-all;
    }
  }
}

.subTable2 {
  font-weight: bold;
}
.subTable3 {
  background-color: #f3f3f3;
  font-weight: bold;
}

.rowSpace {
  width: 100%;
  height: 2rem;
  > hr {
  }
}

.headerimage {
  width: 100%;
  margin: 0;
  content: url('~@/assets/images/pleisure/program/forestorytellingtour_headerimage.jpg');
}

@media (min-width: 992px) {
  .web {
  }

  .mobile {
    display: none;
  }
  .card {
    height: 26rem;
  }
}

@media (max-width: 992px) {
  .headerimage {
    display: none;
  }

  .header {
    position: relative;
    width: 100%;
    padding-top: 5rem;
    > img {
      width: 100%;
    }

    .overlay {
      padding-top: 5rem;
      color: White;
      position: absolute;
      text-align: center;
      z-index: 12;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: lighter;
      letter-spacing: -0.1rem;
    }
  }
  .web {
    display: none;
  }

  .mobile {
  }
}
</style>

<i18n>
{
  "ko": {
    "breadcrumb": "프로그램 안내",
    "forest_title": "제주 숲토리텔링 투어",
    "forest_subtitle": "숲토리텔러와 함께하는 프라이빗 숲 트레킹",
    "prev_button": "이전",
    "reserve_button": "예약신청",
    "forest_desc1": "경이롭고 아름다운 한라산의 자연 속을 걸어보는 시간. 오직 한 팀만을 위한 전담 가이드의 숲토리텔링을 들으며",
    "forest_desc2": "자연과 함께 호흡하고 내면의 활력을 깨우는 자연 치유의 시간을 가져보시기 바랍니다.",
    "forest_desc3": "※ 개인별 기량에 따라 코스는 변경될 수 있습니다.",
    "forest_desc4": "※ 필수 복장 : 편한 바지와 운동화(등산화 등)",
    "forest_desc5": "※ 트래킹 용품 고객 개별 준비 필요",
    "forest_common_title": "공통 의전 및 서비스",
    "forest_common_desc1": "- 차량 의전 서비스 (벤츠 스프린터 / 카니발 하이리무진)",
    "forest_common_desc2": "- 핀크스 의전 담당 매니저 케어",
    "forest_common_desc3": "- 트래킹 Snack&어메니티 제공 및 Kit 대여",
    "forest_common_desc4": "※ Kit : 등산가방, 스틱 등 트래킹 서포트 물품",
    "forest_main_title": "메인 프로그램",
    "forest_mainp_title1": "시즌 트레킹 코스",
    "forest_mainp_desc1": "시즌별로 특화된 제주의 프라이빗 투어 코스 제주의 아름다운 사계절을 느낄 수 있습니다.",
    "forest_mainp_title2": "프라이빗 한라산 트레킹",
    "forest_mainp_desc2": "한라산의 대표적인 코스인 어리목으로 입산하여 영실코스로 하산하는 코스",
    "forest_mainp_title3": "송악산 올레 코스",
    "forest_mainp_desc3": "송악산을 걸으며 산방산, 형제섬 등 제주 남부 해안의 절경을 만나보세요.",
    "forest_table1_tr1_td1": "옵션",
    "forest_table1_tr1_td2": "최대인원",
    "forest_table1_tr1_td3": "소요시간",
    "forest_table1_tr1_td4": "요금(2인기준)",
    "forest_table1_tr1_td5": "추가옵션",
    "forest_table1_tr2_td1": "시즌 트레킹 코스",
    "forest_table1_tr2_td2": "6인",
    "forest_table1_tr2_td3": "3 ~ 3.5H",
    "forest_table1_tr2_td4": "400,000",
    "forest_table1_tr2_td5": "※ 인원추가 +100,000 원 / 인",
    "forest_table1_tr3_td1": "프라이빗 한라산 트레킹",
    "forest_table1_tr3_td2": "5 ~ 5.5H",
    "forest_table1_tr3_td3": "500,000",
    "forest_table1_tr4_td1": "송악산 올레 코스",
    "forest_table1_tr4_td2": "3 ~ 3.5H",
    "forest_table1_tr4_td3": "400,000",
    "forest_addition_title": "추가옵션",
    "forest_table2_tr1_td1": "구분",
    "forest_table2_tr1_td2": "옵션(2인기준)",
    "forest_table2_tr2_td1": "150,000",
    "forest_table2_tr2_td2": "수테라피, 사격, 오모로비짜 스파(40분)",
    "forest_table2_tr2_td3": "※ 3인 이상 시 전화 문의",
    "forest_table2_tr3_td1": "200,000",
    "forest_table2_tr3_td2": "메디컬 스파(바디)",
    "forest_table2_tr4_td1": "350,000",
    "forest_table2_tr4_td2": "오모로비짜 스파(90분)",
    "forest_table2_tr5_td1": "플라워 세팅",
    "forest_table2_tr5_td2": "300,000 / 500,000 / 700,000",
    "forest_etc_title": "기타사항",
    "forest_etc_desc1": "※ 5세 이상부터 1인 요금이 적용됩니다.",
    "forest_etc_desc2": "※ 경우에 따라 미성년자의 경우에는 보호자 동반이 필요할 수 있습니다.",
    "forest_etc_desc3": "※ 단순 고객변심에 의한 취소/환불은 업체 위약 규정에 따라 적용됩니다.",
    "forest_etc_desc4": "- 7일 전 위약금 0%, 6일 전 ~ 5일 전 30%, 4일 전 50%, 3일 전~2일 전(~17시) 70%, 2일전(17시~) ~ 당일 100% 위약금 부과",
    "forest_etc_desc5": "※ 천재지변 및 업체의 운영 상 부득이한 상황으로 취소 시, 위약 규정이 적용되지 않습니다.",
    "forest_etc_desc6": "※ 여행자보험 포함 상품입니다.",
    "forest_etc_desc7": "※ 요금표 외 기타 인원은 전화 문의"
  },
  "en": {
    "breadcrumb": "Program Information",
    "forest_title": "Jeju Sooptorytelling Tour(Forest Trekking)",
    "forest_subtitle": "Private forest trekking with the forest storyteller.",
    "prev_button": "Previous",
    "reserve_button": "Book Now",
    "forest_desc1": "Time to walk through the wonderful and beautiful nature of Hallasan Mountain. Listen to the forest story telling(Sooptoryelling) from the special guide for only one team.",
    "forest_desc2": "Take a time to breathe with the nature and experience natural healing to awaken your inner vitality.",
    "forest_desc3": "※ The course is subject to change depending on individual ability.",
    "forest_desc4": "※ Required to wear: comfortable pants and sneakers (climbing boots, etc.)",
    "forest_desc5": "※ Customers must prepare their own trekking equipment.",
    "forest_common_title": "Common escort service and other services",
    "forest_common_desc1": "- Escort vehicle service (Benz Sprinter / Carnival High Limousine)",
    "forest_common_desc2": "- Care service by the PINX escort manager",
    "forest_common_desc3": "- Tracking Snack & Amenity Offering and Kit Rental",
    "forest_common_desc4": "※ Kit: Tracking support items such as hiking bags and sticks",
    "forest_main_title": "Main Program",
    "forest_mainp_title1": "Dol-oreum Up course/down course",
    "forest_mainp_desc1": "편백나무와 삼나무 숲길, 용바위, 판상절리 계곡 등이 포함 된 트래킹",
    "forest_mainp_title2": "Private Mt.Halla trekking",
    "forest_mainp_desc2": "Trekking course includes cypress and cedar tree trails, Yongbawi Rock, and plate joint valley. Course starts at Eorimok, a representative course of Hallasan Mountain, and goes down to Yeongsil course.",
    "forest_table1_tr1_td1": "Optioin",
    "forest_table1_tr1_td2": "Maximum Occupancy",
    "forest_table1_tr1_td3": "Running Time",
    "forest_table1_tr1_td4": "Fare(2 people)",
    "forest_table1_tr1_td5": "Addtional option",
    "forest_table1_tr2_td1": "Dol-oreum Up/down course",
    "forest_table1_tr2_td2": "6 person",
    "forest_table1_tr2_td3": "3 ~ 3.5H",
    "forest_table1_tr2_td4": "KRW 400,000",
    "forest_table1_tr2_td5": "※ Additional person + KRW 100,000 / 1people",
    "forest_table1_tr3_td1": "Private Mt.Halla trekking",
    "forest_table1_tr3_td2": "5 ~ 5.5H",
    "forest_table1_tr3_td3": "KRW 500,000",
    "forest_addition_title": "Addtional Options",
    "forest_table2_tr1_td1": "Fare",
    "forest_table2_tr1_td2": "Option(2 person)",
    "forest_table2_tr2_td1": "KRW 150,000",
    "forest_table2_tr2_td2": "Water therapy, Shooting, Omorovicza Spa(40min.)",
    "forest_table2_tr2_td3": "※ More than 3 people, please contact us",
    "forest_table2_tr3_td1": "KRW 200,000",
    "forest_table2_tr3_td2": "Medical Spa(Body)",
    "forest_table2_tr4_td1": "KRW 350,000",
    "forest_table2_tr4_td2": "Omorovicza Spa(90min.)",
    "forest_table2_tr5_td1": "Flower service",
    "forest_table2_tr5_td2": "KRW 300,000 / 500,000 / 700,000",
    "forest_etc_title": "Others",
    "forest_etc_desc1": "※ A fare applies for children aged 5 or older.",
    "forest_etc_desc2": "※ In some cases, minors may need a guardian.",
    "forest_etc_desc3": "※ The company’s cancellation policy shall apply in the case of cancellation or refund due to a simple change in mind.",
    "forest_etc_desc4": "- Penalty will be charged 0% until 7 days prior to the reserved date, 30% from 5 to 6 days before, 50% until 4 days before, 70% until 2 to 3 days before (by 5pm), and no refund will be made(100% penalty) after 5pm 2 days prior to the reserved date.",
    "forest_etc_desc5": "※ In case of cancellation due to natural disasters or unavoidable circumstances due to the company's operational reason, the cancellation policy shall not apply.",
    "forest_etc_desc6": "※ Traveler's insurance is included in the product.",
    "forest_etc_desc7": "※ Contact us by phone for the group of people other than the number in the price list."
  },
  "ja": {
    "breadcrumb": "프로그램 안내",
    "forest_title": "제주 숲토리텔링 투어",
    "forest_subtitle": "숲토리텔러와 함께하는 프라이빗 숲 트레킹",
    "prev_button": "이전",
    "reserve_button": "예약신청",
    "forest_desc1": "경이롭고 아름다운 한라산의 자연 속을 걸어보는 시간. 오직 한 팀만을 위한 전담 가이드의 숲토리텔링을 들으며",
    "forest_desc2": "자연과 함께 호흡하고 내면의 활력을 깨우는 자연 치유의 시간을 가져보시기 바랍니다.",
    "forest_desc3": "※ 개인별 기량에 따라 코스는 변경될 수 있습니다.",
    "forest_desc4": "※ 필수 복장 : 편한 바지와 운동화(등산화 등)",
    "forest_desc5": "※ 트래킹 용품 고객 개별 준비 필요",
    "forest_common_title": "공통 의전 및 서비스",
    "forest_common_desc1": "- 차량 의전 서비스 (벤츠 스프린터 / 카니발 하이리무진)",
    "forest_common_desc2": "- 핀크스 의전 담당 매니저 케어",
    "forest_common_desc3": "- 트래킹 Snack&어메니티 제공 및 Kit 대여",
    "forest_common_desc4": "※ Kit : 등산가방, 스틱 등 트래킹 서포트 물품",
    "forest_main_title": "메인 프로그램",
    "forest_mainp_title1": "돌오름 Up 코스 / Down 코스",
    "forest_mainp_desc1": "편백나무와 삼나무 숲길, 용바위, 판상절리 계곡 등이 포함 된 트래킹",
    "forest_mainp_title2": "프라이빗 한라산 트래킹",
    "forest_mainp_desc2": "한라산의 대표적인 코스인 어리목으로 입산하여 영실코스로 하산하는 코스",
    "forest_table1_tr1_td1": "옵션",
    "forest_table1_tr1_td2": "최대인원",
    "forest_table1_tr1_td3": "소요시간",
    "forest_table1_tr1_td4": "요금(2인기준)",
    "forest_table1_tr1_td5": "추가옵션",
    "forest_table1_tr2_td1": "돌오름 Up/Down 코스",
    "forest_table1_tr2_td2": "6인",
    "forest_table1_tr2_td3": "3 ~ 3.5H",
    "forest_table1_tr2_td4": "400,000",
    "forest_table1_tr2_td5": "※ 인원추가 +100,000 원 / 인",
    "forest_table1_tr3_td1": "프라이빗 한라산 트레킹",
    "forest_table1_tr3_td2": "5 ~ 5.5H",
    "forest_table1_tr3_td3": "500,000",
    "forest_addition_title": "추가옵션",
    "forest_table2_tr1_td1": "구분",
    "forest_table2_tr1_td2": "옵션(2인기준)",
    "forest_table2_tr2_td1": "150,000",
    "forest_table2_tr2_td2": "수테라피, 사격, 오모로비짜 스파(40분)",
    "forest_table2_tr2_td3": "※ 3인 이상 시 전화 문의",
    "forest_table2_tr3_td1": "200,000",
    "forest_table2_tr3_td2": "메디컬 스파(바디)",
    "forest_table2_tr4_td1": "350,000",
    "forest_table2_tr4_td2": "오모로비짜 스파(90분)",
    "forest_table2_tr5_td1": "플라워 세팅",
    "forest_table2_tr5_td2": "300,000 / 500,000 / 700,000",
    "forest_etc_title": "기타사항",
    "forest_etc_desc1": "※ 5세 이상부터 1인 요금이 적용됩니다.",
    "forest_etc_desc2": "※ 경우에 따라 미성년자의 경우에는 보호자 동반이 필요할 수 있습니다.",
    "forest_etc_desc3": "※ 단순 고객변심에 의한 취소/환불은 업체 위약 규정에 따라 적용됩니다.",
    "forest_etc_desc4": "- 7일 전 위약금 0%, 6일 전 ~ 5일 전 30%, 4일 전 50%, 3일 전~2일 전(~17시) 70%, 2일전(17시~) ~ 당일 100% 위약금 부과",
    "forest_etc_desc5": "※ 천재지변 및 업체의 운영 상 부득이한 상황으로 취소 시, 위약 규정이 적용되지 않습니다.",
    "forest_etc_desc6": "※ 여행자보험 포함 상품입니다.",
    "forest_etc_desc7": "※ 요금표 외 기타 인원은 전화 문의"
  }
}
</i18n>
